export default {
	billingCompanyDetails: state => state.billingCompanyDetails,
	billingCompanyDetailsMeta: state => state.billingCompanyDetailsMeta,
	billingCompanyDetail: state => state.billingCompanyDetail,
	billingSeriesPolicies: state => state.billingSeriesPolicies,
	billingSeriesPolicy: state => state.billingSeriesPolicy,
	billingSeriesPoliciesMeta: state => state.billingSeriesPoliciesMeta,
	billingDocumentConfigs: state => state.billingDocumentConfigs,
	billingDocumentConfig: state => state.billingDocumentConfig,
	billingDocumentConfigsMeta: state => state.billingDocumentConfigsMeta,
	billingDebetasDimensionDetail: state => state.billingDebetasDimensionDetail,
	billingDebetasDimensionDetails: state => state.billingDebetasDimensionDetails,
	billingDebetasDimensionHeader: state => state.billingDebetasDimensionHeader,
	billingDebetasDimensionHeaders: state => state.billingDebetasDimensionHeaders,
	billingDebetasDimensionHeaderDataFields: state => state.billingDebetasDimensionHeaderDataFields,
	billingCashRegisters: state => state.billingCashRegisters,
	billingCashRegister: state => state.billingCashRegister,
	billingCashRegistersMeta: state => state.billingCashRegistersMeta,
	billingCashRegisterSeriesPolicies: state => state.billingCashRegisterSeriesPolicies,
	billingRecords: state => state.billingRecords,
	billingRecord: state => state.billingRecord,
	billingRecordRelatedOrder: state => state.billingRecordRelatedOrder,
	billingRecordsMeta: state => state.billingRecordsMeta,
	billingAccountingExportConfig: state => state.billingAccountingExportConfig,
	billingDocumentItemDescriptionGroups: state => state.billingDocumentItemDescriptionGroups,
	billingDocumentItemDescriptionGroupsMeta: state => state.billingDocumentItemDescriptionGroupsMeta,
	billingDocumentItemDescriptionGroup: state => state.billingDocumentItemDescriptionGroup,
	billingDocumentItemDescriptions: state => state.billingDocumentItemDescriptions,
	billingDocumentItemDescriptionsMeta: state => state.billingDocumentItemDescriptionsMeta,
	loading: state => state.loading,
	searchFilters: state => state.searchFilters
}
